import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import styled from "styled-components"
import { Button, Input } from "../../../ui/ot"
import { Select } from "../../../ui/select"
import { SelectContent, SelectItem, SelectTrigger, SelectValue, } from "../../../ui/ot"
import { Row, Col } from '../../../ui/ot'
import { Calendar } from "../../../ui/ot"
import { useForm, useFieldArray, useWatch } from "react-hook-form"
import { z } from 'zod'
import { zodResolver } from "@hookform/resolvers/zod"
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../../ui/form"
import { RadioGroup, RadioGroupItem } from "../../../ui/radio-group"
import { CalendarIcon } from "lucide-react"
import dayjs from 'dayjs'
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "../../../ui/popover"
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
} from "../../../ui/table"
import { Checkbox } from "../../../ui/checkbox"
import { usePatronCategory } from '../../controllers/PatronCategoryController';
import { useMessageType } from '../../controllers/MessageTypeController'
import { useLibrary } from '../../controllers/LibraryController'
import MultipleSelector from '../../../ui/multiple-selector';

const PatronCategoriesForm = forwardRef(({
    onFormFinish = () => { },
}, ref) => {
    const thisJS = "PatronCategoriesForm"
    const formRef = useRef()
    const dateSchema = z.union([
        z.date(),
        z.string().refine((val) => !isNaN(Date.parse(val)), {
            message: "Invalid date string",
        }).transform((val) => new Date(val)),
        z.undefined()
    ]);
    const messageObj = z.object({
        "borrower_message_preference_id": z.number(),
        "message_attribute_id": z.number(), //設定拉出的
        "message_name": z.string(), //設定拉出的
        "takes_days": z.number().nullish(), // 是否能設定 Days in advance
        "days_in_advance": z.number().nullish(), //填寫值
        "email": z.optional(z.number()),//填寫值
        "wants_digest": z.number().nullish(),//填寫值
        "canset_digest": z.optional(z.number().nullish()),//是否能設定 wants_digest
    });
    const formSchema = z.object({
        categorycode: z.string({ required_error: "此為必填", }),
        "description": z.string({ required_error: "此為必填", }),
        "enrolmentperiod": z.string().optional(),
        "enrolmentperioddate": dateSchema.optional(),
        "password_expiry_days": z.number().optional(),
        "upperagelimit": z.number().nullish(),
        "dateofbirthrequired": z.number().nullish(),
        "enrolmentfee": z.number().nullish(),
        "overduenoticerequired": z.string(),
        "hidelostitems": z.string().nullish(),
        "reservefee": z.number().nullish(),
        "category_type": z.string({ required_error: "此為必填", }),
        "can_be_guarantee": z.string().nullish(),
        "reset_password": z.string().optional(),
        "change_password": z.string().optional(),
        "min_password_length": z.number().optional(),
        "require_strong_password": z.string().nullish(),
        "BlockExpiredPatronOpacActions": z.string().optional(),
        "default_privacy": z.string(),
        "exclude_from_local_holds_priority": z.string().nullish(),
        branches: z.array(z.object({
            label: z.string(),
            value: z.string()
        })),
        message: z.array(messageObj)
    })
    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            enrolmentperioddate: undefined,
            overduenoticerequired: "0",
            hidelostitems: "0",
            can_be_guarantee: "0",
            default_privacy: "default",
            exclude_from_local_holds_priority: "0",
        },
    })

    const MessageName = ({ control, fieldId }) => {
        const messages = useWatch({
            control,
            name: "message",
        })
        let message = messages[fieldId]
        let messageName = message?.message_name
        return (<SubTitle>
            {messageName}
        </SubTitle>)
    }
    const DaysInAdvance = ({ control, field, index, register }) => {
        const messages = useWatch({
            control,
            name: "message",
        })
        let message = messages[index]
        if (message?.takes_days === 1) {
            return (<Input
                type='number'
                key={field.id}
                value={0}
                placeholder="請輸入..."
                {...field}
                {...register}
            />)
        }
        else {
            return (<>-</>)
        }
    }
    const NormalCheckBox = ({ control, field, index, register }) => {
        //const messages = useWatch({ control, name: "message", })
        return (<Checkbox
            checked={field.value === 1}
            onCheckedChange={(checked) => { return checked ? field.onChange(1) : field.onChange(0) }}
        />)
    }
    const DigestsOnlyCheck = ({ control, field, index, register }) => {
        const messages = useWatch({
            control,
            name: "message",
        })
        let message = messages[index]
        if (message?.canset_digest === 1) {
            //const field = form.register(`message[${index}].wants_digest`)
            const iValue = message?.email === 1 && field.value === 1 ? 1 : 0
            if (iValue !== field.value) { field.onChange(iValue) }
            return (<Checkbox
                checked={field.value === 1}
                disabled={message?.email === 0}
                onCheckedChange={(checked) => {
                    return checked
                        ? field.onChange(1)
                        : field.onChange(0)
                }}
            />)
        }
        else {
            return (<>-</>)
        }
    }
    const {
        fields: messageFields,
        append: messageAppend,
        remove: messageRemove
    } = useFieldArray({
        control: form.control,
        name: "message"
    });
    const onSubmit = (values) => {
        let message = values?.message
        let branches = values?.branches.map((val) => {
            return val?.value
        })
        message = message.map((value) => {
            return {
                ...value,
                days_in_advance: value?.days_in_advance || null,
                wants_digest: value?.wants_digest || 0,
                email: value?.email || 0,
            }
        })
        values = {
            ...values,
            message,
            branches
        }
        onFormFinish(values)
    }
    const onError = (e) => {
        console.log(e)
    }
    //parent component can use function 
    useImperativeHandle(ref, () => {
        return {
            onFormSubmit: () => {
                formRef.current.requestSubmit();
            },
            setValue: (name, value, config) => {
                form.setValue(name, value, config)
            },
            setValues: (values) => {
                if (typeof values === 'object') {
                    Object.keys(values).forEach((element) => {
                        form.setValue(element, values[element])
                    })
                }
            },
            getValues: (name) => {
                return form.getValues(name)
            },
        };
    }, []);

    const {
        PatronCategoryTypeData,
        getPatronCategoryTypeData
    } = usePatronCategory({
        onBefore: () => { },
        onFinish: ({ axiosMode, status, values }) => {
            if (axiosMode === "get") {
                if (status === "success") {

                }
            }
        }
    })
    const {
        MessageTypeData,
        getMessageTypeData
    } = useMessageType({
        onBefore: () => { },
        onFinish: ({ axiosMode, status, values }) => { }
    })
    const {
        LibraryData,
        getLibraryData
    } = useLibrary({
        onBefore: ({ axiosMode, values }) => { console.log(thisJS, "LibraryData", axiosMode, "onBefore", values) },
        onFinish: ({ axiosMode, status, values }) => { console.log(thisJS, "LibraryData", axiosMode, "onFinish", status, values)}
    })
    useEffect(() => {
        getPatronCategoryTypeData({})
        getLibraryData({})
    }, [])
    useEffect(() => {
        if (form.getValues('message').length === 0) {
            form.setValue('message', MessageTypeData)
        }
    }, [MessageTypeData])
    return (
        <Form {...form}>
            <form
                ref={formRef}
                autoComplete="off"
                onSubmit={form.handleSubmit(onSubmit, onError)}
            >
                <Row gutter={[16, 16]}>
                    <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Category Code</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="categorycode"
                                    render={({ field }) => (
                                        <FormItem>
                                            <FormControl>
                                                <Em10>
                                                    <Input
                                                        key={field.id} placeholder="請輸入..." value={field.value}
                                                        {...field}
                                                    />
                                                </Em10>
                                            </FormControl>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Description</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="description"
                                    render={({ field }) => (
                                        <FormItem>
                                            <FormControl>
                                                <Em10>
                                                    <Input
                                                        key={field.id}
                                                        placeholder="請輸入..."
                                                        {...field}

                                                    />
                                                </Em10>
                                            </FormControl>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Enrolment Period</SubTitle></Col>
                            <Col>
                                <Row>
                                    <Col><SubTitle>請選擇一項</SubTitle></Col>
                                </Row>
                                <Row gutter={[8, 8]}>
                                    <Col><SubTitle>In months</SubTitle></Col>
                                    <Col>
                                        <FormField
                                            control={form.control}
                                            name="enrolmentperiod"
                                            render={({ field }) => (
                                                <FormItem >
                                                    <FormControl>
                                                        <Input
                                                            type="number"
                                                            key={field.id}
                                                            {...field}
                                                        />
                                                    </FormControl>
                                                    <FormMessage />
                                                </FormItem>
                                            )}
                                        />
                                    </Col>
                                    <Col><SubTitle>個月</SubTitle></Col>
                                </Row>
                                <Row gutter={[8, 8]}>
                                    <Col>
                                        <SubTitle>Until date</SubTitle>
                                    </Col>
                                    <Col>
                                        <FormField
                                            control={form.control}
                                            name="enrolmentperioddate"
                                            render={({ field }) => (
                                                <FormItem >
                                                    <Popover>
                                                        <PopoverTrigger asChild>
                                                            <FormControl>
                                                                <Button
                                                                    variant={"outline"}
                                                                >
                                                                    {field.value ? (
                                                                        dayjs(field.value).format("YYYY-MM-DD")
                                                                    ) : (
                                                                        <span>選擇日期</span>
                                                                    )}
                                                                    <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                                                                </Button>
                                                            </FormControl>
                                                        </PopoverTrigger>
                                                        <PopoverContent className="w-auto p-0" align="start">
                                                            <Calendar
                                                                mode="single"
                                                                selected={field.value}
                                                                onSelect={field.onChange}
                                                                disabled={(date) =>
                                                                    date > new Date() || date < new Date("1900-01-01")
                                                                }
                                                                initialFocus
                                                                {...form.register("enrolmentperioddate", {
                                                                    required: false
                                                                })}
                                                            />
                                                        </PopoverContent>
                                                    </Popover>
                                                    <FormMessage />
                                                </FormItem>
                                            )}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Password Expiration</SubTitle></Col>
                            <Col>
                                <Row gutter={[4, 4]}>
                                    <Col>
                                        <FormField
                                            control={form.control}
                                            name="password_expiry_days"
                                            render={({ field }) => (
                                                <FormItem>
                                                    <FormControl>
                                                        <Em10>
                                                            <Input
                                                                type="number"
                                                                key={field.id}
                                                                {...field}
                                                                {...form.register("password_expiry_days", {
                                                                    required: false,
                                                                    setValueAs: (v) => v === "" ? undefined : parseInt(v, 10),
                                                                })}
                                                            />
                                                        </Em10>
                                                    </FormControl>
                                                    <FormMessage />
                                                </FormItem>
                                            )}
                                        />
                                    </Col>
                                    <Col><SubTitle>天</SubTitle></Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Age required</SubTitle></Col>
                            <Col>
                                <Row gutter={[4, 4]}>
                                    <Col>
                                        <FormField
                                            control={form.control}
                                            name="dateofbirthrequired"
                                            render={({ field }) => (
                                                <FormItem>
                                                    <FormControl>
                                                        <Em10>
                                                            <Input
                                                                type="number"
                                                                key={field.id}
                                                                {...field}
                                                                {...form.register("dateofbirthrequired", {
                                                                    required: false,
                                                                    setValueAs: (v) => v === "" ? undefined : parseInt(v, 10),
                                                                })}
                                                            />
                                                        </Em10>
                                                    </FormControl>
                                                    <FormMessage />
                                                </FormItem>
                                            )}
                                        />
                                    </Col>
                                    <Col><SubTitle>年</SubTitle></Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Upperage Limit</SubTitle></Col>
                            <Col>
                                <Row gutter={[4, 4]}>
                                    <Col>
                                        <FormField
                                            control={form.control}
                                            name="upperagelimit"
                                            render={({ field }) => (
                                                <FormItem>
                                                    <FormControl>
                                                        <Em10>
                                                            <Input type="number" key={field.id}    {...field}
                                                                {...form.register("upperagelimit", {
                                                                    required: false,
                                                                    setValueAs: (v) => v === "" ? undefined : parseInt(v, 10),
                                                                })}
                                                            />
                                                        </Em10>
                                                    </FormControl>
                                                    <FormMessage />
                                                </FormItem>
                                            )}
                                        />
                                    </Col>
                                    <Col><SubTitle>年</SubTitle></Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Enrolment fee</SubTitle></Col>
                            <Col>
                                <Row gutter={[4, 4]}>
                                    <Col>
                                        <FormField
                                            control={form.control}
                                            name="enrolmentfee"
                                            render={({ field }) => (
                                                <FormItem>
                                                    <FormControl>
                                                        <Em10>
                                                            <Input
                                                                type="number"
                                                                step="0.01"
                                                                key={field.id}
                                                                {...field}
                                                                {...form.register("enrolmentfee", {
                                                                    required: false,
                                                                    setValueAs: (v) => v === "" ? undefined : parseFloat(v, 10),
                                                                })}
                                                            />
                                                        </Em10>
                                                    </FormControl>
                                                    <FormMessage />
                                                </FormItem>
                                            )}
                                        />
                                    </Col>
                                    <Col><SubTitle>年</SubTitle></Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Overdue notice required</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="overduenoticerequired"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select
                                                onValueChange={field.onChange}
                                                defaultValue={field.value} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger>
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value={"1"}><span className="text-nowrap">是</span></SelectItem>
                                                    <SelectItem value={"0"}><span className="text-nowrap">否</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Lost items in staff interface</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="hidelostitems"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger>
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value={"1"}><span>Hidden</span></SelectItem>
                                                    <SelectItem value={"0"}><span>Shown</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Hold fee</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="reservefee"
                                    render={({ field }) => (
                                        <FormItem>
                                            <FormControl>
                                                <Em10>
                                                    <Input
                                                        step={'0.01'}
                                                        type="number" key={field.id}    {...field}
                                                        {...form.register("reservefee", {
                                                            required: false,
                                                            setValueAs: (v) => v === "" ? undefined : parseFloat(v, 10),
                                                        })}
                                                    />
                                                </Em10>
                                            </FormControl>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Category type</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="category_type"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value ?? "-1"} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger >
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    {
                                                        field.value == null && (
                                                            <SelectItem value={"-1"}><span>Select a category type</span></SelectItem>
                                                        )
                                                    }
                                                    {
                                                        (PatronCategoryTypeData || []).map((value, index) => {
                                                            return (
                                                                <SelectItem key={field.id + "_" + index} value={value?.value}><span>{value?.text}</span></SelectItem>
                                                            )
                                                        })
                                                    }
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Can be guarantee</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="can_be_guarantee"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value} value={field.value ?? "0"}>
                                                <FormControl>
                                                    <SelectTrigger>
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value="1"><span>yes</span></SelectItem>
                                                    <SelectItem value="0"><span>no</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Library limitations</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="branches"
                                    render={({ field }) => (
                                        <FormItem>
                                            <MultipleSelector
                                                value={field.value}
                                                style={
                                                    {
                                                        minWidth: "200px"
                                                    }
                                                }
                                                onChange={(e) => {
                                                    field.onChange(e)
                                                }}
                                                selectFirstItem={false}
                                                options={LibraryData.map((value) => {
                                                    return {
                                                        label: value?.branchname,
                                                        value: value?.branchcode,
                                                    }
                                                })}
                                                placeholder="請輸入"
                                                creatable={true}
                                                emptyIndicator={
                                                    <p className="text-center text-lg leading-10 text-gray-600 dark:text-gray-400">
                                                        沒有選項
                                                    </p>
                                                }
                                            />
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Password reset in OPAC</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="reset_password"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value ?? "-1"} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger>
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value={'-1'}><span>Follow system perference OpacPrsetPassword(disabled)</span></SelectItem>
                                                    <SelectItem value={'1'}><span>Allowed</span></SelectItem>
                                                    <SelectItem value={'0'}><span>not allowed</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Password change in OPAC</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="change_password"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value ?? "-1"} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger>
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value={'-1'}><span>Follow system perference OpacPrsetPassword(enabled)</span></SelectItem>
                                                    <SelectItem value={'1'}><span>Allowed</span></SelectItem>
                                                    <SelectItem value={'0'}><span>not allowed</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Minimum password length</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="min_password_length"
                                    render={({ field }) => (
                                        <FormItem>
                                            <FormControl>
                                                <Em10>
                                                    <Input type="number" key={field.id}    {...field}
                                                        {...form.register("min_password_length", {
                                                            required: false,
                                                            setValueAs: (v) => v === "" ? undefined : parseInt(v, 10),
                                                        })}
                                                    />
                                                </Em10>
                                            </FormControl>
                                            <FormDescription>
                                                Leave blank to use system default (8)
                                            </FormDescription>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Require strong password</SubTitle></Col>
                            <Col>
                                <FormField
                                    control={form.control}
                                    name="require_strong_password"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value ?? "-1"} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger >
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value={'-1'}><span>Follow system perference  RequireStrongPassword(yes)</span></SelectItem>
                                                    <SelectItem value={'1'}><span>Yes</span></SelectItem>
                                                    <SelectItem value={'0'}><span>No</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Block expired patrons:</SubTitle></Col>
                            <Col xxl={20} xl={19} lg={17} md={24} sm={24} xs={24}>
                                <FormField
                                    control={form.control}
                                    name="BlockExpiredPatronOpacActions"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value ?? "-1"} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger>
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value={'-1'}><span>Follow system perference  BlockExpiredPatronOpacActions</span></SelectItem>
                                                    <SelectItem value={'1'}><span>Block</span></SelectItem>
                                                    <SelectItem value={'0'}><span>No Block</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormDescription>
                                                Choose whether patrons of this category be blocked from public catalog actions such as renewing and placing holds when their cards have expired.
                                            </FormDescription>
                                            <FormMessage />
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Default privacy:</SubTitle></Col>
                            <Col xxl={17} xl={20} lg={18} md={24} sm={24} xs={24}>
                                <FormField
                                    control={form.control}
                                    name="default_privacy"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger >
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value={'default'}><span>Default</span></SelectItem>
                                                    <SelectItem value={'never'}><span>Never</span></SelectItem>
                                                    <SelectItem value={'forever'}><span>Forever</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormMessage />
                                            <FormDescription>
                                                Controls how long a patrons checkout history is kept for new patrons of this category. "Never" anonymizes checkouts on return, and "Forever" keeps a patron's checkout history indefinitely. When set to "Default", the amount of history kept is controlled by the cronjob batch_anonymise.pl which should be set up by your system administrator.
                                            </FormDescription>
                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[8, 8]}>
                            <Col><SubTitle>Exclude from local holds priority:</SubTitle></Col>
                            <Col xxl={21} xl={18} lg={17} md={24} sm={24} xs={24}>
                                <FormField
                                    control={form.control}
                                    name="exclude_from_local_holds_priority"
                                    render={({ field }) => (
                                        <FormItem>
                                            <Select onValueChange={field.onChange} defaultValue={field.value} value={field.value}>
                                                <FormControl>
                                                    <SelectTrigger>
                                                        <SelectValue />
                                                    </SelectTrigger>
                                                </FormControl>
                                                <SelectContent>
                                                    <SelectItem value={"1"}><span>Yes</span></SelectItem>
                                                    <SelectItem value={"0"}><span>No</span></SelectItem>
                                                </SelectContent>
                                            </Select>
                                            <FormDescription>
                                                If Yes, holds placed by patrons of this category will not be given priority
                                            </FormDescription>
                                            <FormMessage />

                                        </FormItem>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row>
                            <Col span={24}>
                                <SubTitle>Default messaging preferences for this patron category</SubTitle>
                            </Col>
                            <Col span={24}>
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead  > </TableHead>
                                            <TableHead>Days in advance</TableHead>
                                            <TableHead>Email</TableHead>
                                            <TableHead  >Digests only</TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {messageFields.map((field, index) => {
                                            return (
                                                <TableRow key={field.id}>
                                                    <TableCell className="font-medium">
                                                        <MessageName
                                                            control={form.control}
                                                            fieldId={index}
                                                        />
                                                        <FormField
                                                            control={form.control}
                                                            name={`message.${index}.message_attribute_id`}
                                                            render={({ field }) => (
                                                                <FormItem>
                                                                    <FormControl>
                                                                        <Input
                                                                            hidden={true}
                                                                            key={field.id}
                                                                            {...field}
                                                                            {...form.register(`message.${index}.message_attribute_id`, {
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                    </FormControl>
                                                                    <FormMessage />
                                                                </FormItem>
                                                            )}
                                                        />
                                                        <FormField
                                                            control={form.control}
                                                            name={`message.${index}.borrower_message_preference_id`}
                                                            render={({ field }) => (
                                                                <FormItem>
                                                                    <FormControl>
                                                                        <Input
                                                                            hidden={true}
                                                                            key={field.id}  {...field}
                                                                            {...form.register(`message.${index}.borrower_message_preference_id`, {
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                    </FormControl>
                                                                    <FormMessage />
                                                                </FormItem>
                                                            )}
                                                        />
                                                        <FormField
                                                            control={form.control}
                                                            name={`message.${index}.message_name`}
                                                            render={({ field }) => (
                                                                <FormItem>
                                                                    <FormControl>
                                                                        <Input
                                                                            hidden={true}
                                                                            key={field.id}
                                                                            {...field}
                                                                            {...form.register(`message.${index}.message_name`, {
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                    </FormControl>
                                                                    <FormMessage />
                                                                </FormItem>
                                                            )}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormField
                                                            control={form.control}
                                                            name={`message.${index}.days_in_advance`}
                                                            render={({ field }) => (
                                                                <FormItem>
                                                                    <FormControl>
                                                                        <DaysInAdvance
                                                                            control={form.control}
                                                                            field={field}
                                                                            index={index}
                                                                            register={{
                                                                                ...form.register(`message.${index}.days_in_advance`, {
                                                                                    required: false,
                                                                                    setValueAs: (v) => v === "" ? undefined : parseInt(v, 10),
                                                                                })
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                    <FormMessage />
                                                                </FormItem>
                                                            )}
                                                        /></TableCell>
                                                    <TableCell>
                                                        <FormField
                                                            control={form.control}
                                                            name={`message.${index}.email`}
                                                            render={({ field }) => (
                                                                <FormItem>
                                                                    <FormControl>
                                                                        <NormalCheckBox
                                                                            control={form.control}
                                                                            field={field}
                                                                            index={index}
                                                                            register={{
                                                                                ...form.register(`message.${index}.email`, {
                                                                                    required: false,
                                                                                    // setValueAs: (v) => v === "" ? undefined : parseInt(v, 10),
                                                                                })
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                    <FormMessage />
                                                                </FormItem>
                                                            )}
                                                        />
                                                    </TableCell>
                                                    <TableCell  >
                                                        <FormField
                                                            control={form.control}
                                                            name={`message.${index}.canset_digest`}
                                                            render={({ field }) => (
                                                                <FormItem>
                                                                    <FormControl>
                                                                        {<Input
                                                                            hidden={true}
                                                                            key={field.id}
                                                                            {...field}

                                                                        />}

                                                                    </FormControl>
                                                                    <FormMessage />
                                                                </FormItem>
                                                            )}
                                                        />
                                                        <FormField
                                                            control={form.control}
                                                            name={`message.${index}.wants_digest`}
                                                            render={({ field }) => (
                                                                <FormItem>
                                                                    <FormControl>
                                                                        {<DigestsOnlyCheck
                                                                            control={form.control}
                                                                            field={field}
                                                                            index={index}
                                                                            register={{
                                                                                ...form.register(`message.${index}.wants_digest`, {
                                                                                    required: false,
                                                                                    setValueAs: (v) => v === "" ? undefined : parseInt(v, 10),
                                                                                })
                                                                            }}
                                                                        />}

                                                                    </FormControl>
                                                                    <FormMessage />
                                                                </FormItem>
                                                            )}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>

                            </Col>
                        </Row>
                    </Col>
                </Row>
            </form>
        </Form>
    )
})

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const FlexBox = styled.div`
display: flex;
gap: 1em;
`

const VerticalBox = styled.div`
display: flex;
gap: 1em;
`

const SubTitle = styled.div`
text-align: left;
font-size: 1.2em;
font-weight: 600;
padding-top:0.3rem;
`

const PScontext = styled.div`
font-size: 0.8em;
color: #707070;
text-wrap: nowrap;
align-self: center;

`

const SmallFlexBox = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const ColumnFlexBox = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em10 = styled.div`
width: 10em;
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em20 = styled.div`
width: 20em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

export default PatronCategoriesForm